import React from 'react';
import MediaQuery from 'react-responsive';
import { CONFIGURATION } from '../../constants/config';
import welcomeBg from "../../assets/bg_desktop.jpg";
import welcomeBgMobile from "../../assets/bg_mobile.jpg";

class LandingCarousel extends React.Component {

  static WELCOMETXT = "Welcome to the SLA Learning Center";
  static WELCOMESUBTXT = "Enroll in CE courses, track your CE credits, view your  SLA course history, and more.";

  render() {
    return (
      <div>
        <MediaQuery maxWidth={CONFIGURATION.MAX_XS_WIDTH}>
          {(matches) => {
            return (<div className="bannerContainer">
              <img src={matches ? welcomeBgMobile : welcomeBg} />
              <div className="overlay-text"><h2>{LandingCarousel.WELCOMETXT} </h2>
                <div className="welcome-sub">{LandingCarousel.WELCOMESUBTXT}</div>
              </div>
            </div>)
          }}
        </MediaQuery>
      </div>
    );
  }
}


export default LandingCarousel;